module.exports = __webpack_public_path__ + "static/media/RE-empty.c7ddae39.svg";